export const GET_SYSTEM_ALARM_PERIODIC = 'GET_SYSTEM_ALARM_PERIODIC';
export const SYSTEM_ALARM_PERIODIC_UPDATED = 'SYSTEM_ALARM_PERIODIC_UPDATED';